import { ResponsiveTableColumn } from 'modules/shared-components/data-display/table/types';
import { TelegramChannelsRowInfo } from 'api/types/httpsTypes/contracts';
import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import ErrorBoundary from 'components/error-boundaries';
import Table from 'modules/shared-components/data-display/table';
import { thDynamicClass } from '../index';
import { Tabs } from '../../../../components/layout/SIDEBAR_CONST';

interface Props {
  columnsDef: ResponsiveTableColumn<TelegramChannelsRowInfo>[];
  data: TelegramChannelsRowInfo;
}

export const TelegramChannelsRow: FC<Props> = ({ data, columnsDef }) => {
  const history = useHistory();

  return (
    <tr
      onClick={() =>
        history.push({
          pathname: `/dex/research/${Tabs.TelegramChannels}/${data.id}/details`,
          state: {
            from: `${history.location.pathname}${history.location.search}`,
          },
        })
      }
      className="border-t border-dex-black-700 lg:dark:bg-dex-black-900 cursor-pointer items-center hover:dark:lg:bg-dex-black-800 lg:grid lg:grid-cols-8"
    >
      <ErrorBoundary>
        {columnsDef.map((column) => {
          const Column = column.component;
          if (!Column) return;
          return (
            <Table.Td key={column.key} className={thDynamicClass(column.key)}>
              <Column data={data} />
            </Table.Td>
          );
        })}
      </ErrorBoundary>
    </tr>
  );
};
